import { Trans, t } from "@lingui/macro";
import EndScreen from "@root/components/molecules/EndScreen/Component";
import Introduction from "@root/components/molecules/Introduction/Component";
import { GbdView } from "@root/components/organisms/GbdView/Component";
import { GbdViewOverview } from "@root/components/organisms/GbdViewOverview/Component";
import { useAppContext } from "@root/global/context";
import { PreviewArrowCluster } from "@root/icons/Icons";
import { ProgressStateGbd } from "@root/misc/constants";
import { checkTitle, hasValue } from "@root/misc/helpers";
import { useLocation, useParams } from "react-router-dom";

// For each different step in a test, this file renders the HTML for that specific step.

export function Gbd(props: { isOverview?: boolean }): JSX.Element {
  const { progressStateGbd, setProgressStateGbd, gbdData } = useAppContext();
  const location = useLocation();
  const { variant, pages } = useParams();

  if (hasValue(props.isOverview)) {
    return <GbdViewOverview />;
  }

  if (progressStateGbd === ProgressStateGbd.Introduction) {
    return (
      <Introduction
        part={0}
        nextFn={() => setProgressStateGbd(ProgressStateGbd.Instruction)}
        title={checkTitle(location.pathname)}
        nextButtonLabel={t({ id: "gbd.introduction.title", message: "Instructies lezen" })}
        description={
          <>
            <p>
              <Trans id="gbd.introduction">
                Bij deze test gaat het om het concentratie-vermogen; het vermogen om zich te kunnen
                richten op de opgedragen taak.
                <br />
                <br />
              </Trans>
            </p>
            <p>
              <Trans id="gbd.introduction.subtext">
                <strong>
                  Lees de instructie goed door en start de test pas als u deze volledig hebt
                  begrepen.
                </strong>
              </Trans>
            </p>
          </>
        }
      />
    );
  }

  if (progressStateGbd === ProgressStateGbd.Instruction) {
    return (
      <Introduction
        nextFn={() => setProgressStateGbd(ProgressStateGbd.Practise)}
        title={checkTitle(location.pathname)}
        nextButtonLabel={t({ id: "gbd.instruction.title.page1", message: "Oefentest beginnen" })}
        description={
          <>
            <p>
              <Trans id="gbd.instruction">
                Op het scherm zie je een rood vak. Dat rode vak laat zien welke groep stippen je op
                dat moment hebt ingedrukt of waar je nu bent. Met de pijl naar rechts (→) op je
                toetsenbord ga je verder naar de volgende groep stippen.
                <br />
                <br />
                Het doel van de oefening is om alle groepen van vier stippen te doorstrepen. Om een
                groep te doorstrepen druk je op de pijl omhoog (naar boven, ↑). Er komt dan een
                streep door deze groep. Als je een fout maakt en de streep weg wil halen, kun je nog
                een keer op de pijl omhoog (naar boven, ↑) drukken. Dan gaat de streep weg.
                <br />
                <br />
                Met de pijl naar links (←) kun je maximaal één stap terug. Zo kun je een groep
                alsnog doorstrepen of een streep weghalen.
                <br />
                <br />
                Als je een fout maakt, kun je het altijd weer herstellen.
                <br />
                <br />
                Werk snel, maar probeer zo weinig mogelijk fouten te maken!
                <br />
              </Trans>
            </p>
            <PreviewArrowCluster />
          </>
        }
      />
    );
  }

  if (progressStateGbd === ProgressStateGbd.Practise) {
    return (
      <GbdView
        key="practise"
        variant="practise"
        endFn={() => setProgressStateGbd(ProgressStateGbd.Test)}
      />
    );
  }
  if (progressStateGbd === ProgressStateGbd.End) {
    return <EndScreen type="gbd" data={gbdData} variant={variant ?? ""} />;
  }
  return (
    <GbdView
      key="test"
      pages={parseInt(pages ?? "5", 10) ?? 1}
      variant={variant ?? "on-location"}
      endFn={() => setProgressStateGbd(ProgressStateGbd.End)}
    />
  );
}
